<template>
  <div class="modal-wrapper" @click.self="closeModal()">
    <transition name="zoom-in">
      <div class="modal" v-if="opened">
        <div class="modal-header">
          <h3>{{ $t("reporting-modal-header") }}</h3>
        </div>
        <main class="form-wrapper">
          <form @submit.prevent="submit()" class="modal-form">
            <div class="form-row">
              <div class="input-wrapper">
                <input
                  type="email"
                  v-model="inquiry.email"
                  :placeholder="$t('reporting-modal-email')"
                  required
                />
              </div>
            </div>
            <div class="form-row">
              <div class="textarea-wrapper">
                <textarea
                  cols="30"
                  rows="6"
                  v-model="inquiry.message"
                  :placeholder="$t('reporting-modal-message')"
                  required
                ></textarea>
              </div>
            </div>
            <div class="form-row form-submit-row">
              <p>
                {{ $t("reporting-modal-footer") }}
              </p>
              <div class="captcha-and-submit">
                <div class="captcha-wrapper" v-if="captcha && captcha.numOne !== undefined && captcha.numTwo !== undefined">
                  <p>{{ captcha.numOne }} + {{ captcha.numTwo }} =</p>
                  <div class="input-wrapper">
                    <input type="text" v-model="inquiry.captchaSum" />
                  </div>
                </div>
                <a
                  class="link"
                  :class="{ disabled: sendingMail }"
                  @click.prevent="submit"
                  :disabled="sendingMail"
                  tabindex="0"
                >
                  <span class="text-color">{{
                    $t("reporting-modal-submit-btn")
                  }}</span>
                </a>
              </div>
            </div>
          </form>
        </main>

        <footer class="modal-footer">
          <a class="link link--grey" @click.prevent="closeModal()">
            <span class="text-color">{{
              $t("reporting-modal-close-btn")
            }}</span>
          </a>
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>
import inquiry from "../mixins/inquiry.js";
import captcha from "../mixins/captcha.js";

export default {
  props: ["media"],
  mixins: [inquiry, captcha],
  data() {
    return {
      opened: false,
      captcha: null,
      inquiry: {
        email: "",
        message: "",
        captchaSum: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.opened = false;
      setTimeout(() => {
        this.$emit("close");
      }, 200);
    },
    handleEsc(e) {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    },
    submit() {
      this.sendMail(this.inquiry, this.captcha, true)
        .then(() => {
          this.inquiry = {
            email: "",
            message: "",
            captchaSum: "",
          };
          this.captcha = this.getCaptcha();
          this.closeModal();
        })
        .catch(() => {});
    },
    openModalWithCaptcha() {
      this.captcha = this.getCaptcha() 
      setTimeout(() => {
        this.opened = true;
      }, 200);
    },
  },
  mounted() {
    this.openModalWithCaptcha();
    document.addEventListener("keyup", this.handleEsc);
  },
  destroyed() {
    document.removeEventListener("keyup", this.handleEsc);
  },
};
</script>

<style lang="scss" scoped>
.modal {
  // width: calc(90% - 40px);
  max-width: calc(100% - 80px);
  min-width: 950px;
  padding: 40px 100px;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.77, 0, 0.175, 1);

  .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
    margin-bottom: 60px;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #164194;
    }
  }

  .form-wrapper {
    background: rgb(0, 134, 204, 0.1);
    border-left: 11px solid #164194;
    border-radius: 2px;
    padding: 30px 60px 30px 30px;
  }

  .modal-form {
    .form-row {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .input-wrapper {
      height: 40px;
      width: 100%;

      input {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid #0a1f54;
        font-size: 14px;
        height: 100%;
        outline: none;
        width: 100%;

        &::placeholder {
          color: #000;
        }

        &::-webkit-input-placeholder {
          color: #000;
        }

        &::-ms-input-placeholder {
          color: #000;
        }
      }
    }

    .textarea-wrapper {
      height: 80px;
      width: 100%;

      textarea {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid #0a1f54;
        font-size: 14px;
        height: 100%;
        outline: none;
        padding: 0 0 10px;
        width: 100%;
        resize: none;

        &::placeholder {
          color: #000;
        }

        &::-webkit-input-placeholder {
          color: #000;
        }

        &::-ms-input-placeholder {
          color: #000;
        }
      }
    }

    .form-submit-row {
      align-items: center;
      display: flex;
      justify-content: space-between;

      p {
        font-size: 10px;
        line-height: 12px;
        width: 45%;
        margin: 0;

        a {
          text-decoration: underline;
          color: #0a1f54;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .captcha-and-submit {
        display: flex;
        align-items: flex-end;
        gap: 15px;

        .captcha-wrapper {
          display: flex;
          align-items: center;
          flex-grow: 0;
          // gap: 10px;

          p {
            margin: 0;
            font-size: 14px;
            font-weight: 500;
            width: auto;
          }

          .input-wrapper {
            width: 80px;
            margin-right: 0 !important;
            height: initial;

            input {
              text-align: center;
            }
          }
        }

        .link {
          font-size: 14px;
          font-weight: 700;
          text-transform: uppercase;
          padding-bottom: 10px;
          position: relative;
          cursor: pointer;

          span {
            position: relative;
            transition: all 0.3s cubic-bezier(0.77, 0, 0.175, 1);
            z-index: 1;
            color: #0a1f54;
          }

          &::before {
            background-color: #fe5700;
            bottom: 0;
            content: "";
            height: 2px;
            left: 0;
            position: absolute;
            transition: all 0.3s cubic-bezier(0.77, 0, 0.175, 1);
            width: 100%;
            z-index: 0;
          }

          &:hover {
            span {
              color: #fff;
            }

            &::before {
              height: calc(100% + 10px);
              left: -5%;
              width: 110%;
            }
          }
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1280px) {
  .modal {
    max-width: calc(100% - 80px);
    min-width: initial;
    width: 100%;
  }
}

@media screen and (max-width: 1000px) {
  .modal {
    padding: 30px 40px;

    .modal-header {
      margin-bottom: 30px;
    }

    .modal-footer {
      margin-top: 30px;
      margin-bottom: 0;
    }

    .form-wrapper {
      padding: 15px 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  .modal {
    max-width: calc(100% - 40px);
    min-width: initial;
    padding: 20px;

    .modal-header {
      margin-bottom: 20px;
      h3 {
        font-size: 16px;
      }
    }

    .modal-footer {
      margin-top: 20px;
    }

    .form-wrapper {
      padding: 15px;
    }

    .modal-form {
      .form-submit-row {
        flex-direction: column;
        gap: 15px;

        p {
          text-align: center;
          width: 100%;
        }

        .captcha-and-submit {
          flex-direction: column;
          align-items: stretch;
          gap: 10px;

          .captcha-wrapper {
            justify-content: center;
          }

          .link {
            margin-top: 10px;
            text-align: center;
          }
        }
      }
    }
  }
}

.link.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
